import request from '@/utils/request'

/**
 * @param {Object} data
 */

export function login_doReg_api(data) {
    return request({
        url: '/login/doReg',
        method: 'post',
		data
    })
}
// 登陆
export function login_doLogin_api(data) {
    return request({
        url: '/login/doLogin',
        method: 'post',
		data
    })
}


// 验证手机号/邮箱验证码 [忘记密码用]
export function checke_account_api(data) {
    return request({
        url: '/login/checke_account',
        method: 'post',
		data
    })
}

// 重置密码
export function forgot_password_api(data) {
    return request({
        url: '/login/forgot_password',
        method: 'post',
		data
    })
}
// 邮箱验证码发送
export function send_email_code_api(data) {
    return request({
        url: '/api/send_email_code',
        method: 'post',
		data
    })
}
// 手机号验证码发送
export function send_phone_code_api(data) {
    return request({
        url: '/api/send_phone_code',
        method: 'post',
		data
    })
}

// 验证手机号/邮箱验证码 [忘记密码用]
export function login_checke_account_api(data) {
    return request({
        url: '/login/checke_account',
        method: 'post',
        data
    })
}